<style scoped lang="less">
  .editVenue {
    hr {
      margin: 10px;
    }
    .button {
    }
    .panel.permissions {
      padding-left: 15px;
      padding-top: 10px;
    }
  }
</style>
<template>
  <div class="columns editVenue">
    <div class="column is-12">
      <div class="div-table">
        <div class="columns is-gapless">
          <div class="column is-12 card-header has-text-centered button-tools">
            <div
              class="button is-info is-pulled-left"
              @click="goBack()"
            >
              &lt; Back to list
            </div>
            <strong>Edit Venue</strong>
          </div>
        </div>

        <div class="column is-12 editHost">
          <label class="label">Start Date</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <date-picker
                    v-model="venueData.startdate"
                    class="input-date"
                    format="yyyy-MM-dd"
                    use-utc="true"
                    placeholder="Select Date"
                  />
                </p>
              </div>
            </div>
          </div>
          <label class="label">Venue Representative</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.rep"
                    type="text"
                    placeholder="Venue Representative"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>
          <label class="label">E-mail</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.email"
                    type="text"
                    placeholder="E-mail"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>
          <label class="label">Venue Name</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.name"
                    type="text"
                    placeholder="Venue Name"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Active</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <toggle-button
                v-model="venueData.active"
                :width="80"
                :height="30"
                :speed="480"
                :sync="true"
                :labels="{checked: 'Active', unchecked: 'Inactive'}"
                :color="{checked: '#7DCE94', unchecked: '#CCC'}"
              />
            </div>
          </div>

          <label class="label">Street 1</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.street1"
                    type="text"
                    placeholder="Street 1"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Street 2</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.street2"
                    type="text"
                    placeholder="Street 2"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">City</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.city"
                    type="text"
                    placeholder="City"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">State</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.state"
                    type="text"
                    placeholder="State"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Zip Code</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                          v-model="venueData.zip"
                          type="text"
                          placeholder="Zip Code"
                          class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Phone</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.phone"
                    type="text"
                    placeholder="Phone"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Fax</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.fax"
                    type="text"
                    placeholder="Fax"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Region</label>
          <hr>
          <div class="columns">
            <div class="column">
              <div
                v-if="selectedRegion.region"
                class="field"
              >
                <div class="control is-flex">
                  <div
                    class="dropdown"
                    :class="{'is-active': regionDropdown}"
                  >
                    <div class="dropdown-trigger">
                      <button
                        class="button is-small"
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        @click="regionDropdown = !regionDropdown"
                      >
                        <span>{{ selectedRegion.region }}</span>
                        <span class="icon is-small">
                          <i
                            class="far fa-angle-down"
                            aria-hidden="true"
                          />
                        </span>
                      </button>
                    </div>
                    <div
                      class="dropdown-menu"
                      role="menu"
                    >
                      <div
                        v-for="region in regions"
                        class="dropdown-content"
                      >
                        <a
                          class="dropdown-item"
                          @click="selectRegion(region)"
                        >
                          {{ region.region }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <label class="label">Logo</label>
          <hr>
          <div class="columns">
            <div class="column is-6">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.logo"
                    type="text"
                    placeholder="Logo"
                    class="input"
                  >
                  <br>
                </p><h1><strong>OR</strong></h1>
                <vue-dropzone
                  id="dropzone"
                  ref="venueLogo"
                  :options="dropzoneOptions"
                  @vdropzone-success="getVenueLogoLink"
                />
                </p>
              </div>
            </div>
            <div
              class="column is-6"
              style="border-left:3px solid #545454; margin-left:15px;"
            >
              <div
                class="field"
                style="padding-left:25px;"
              >
                <p class="control">
                  <img
                    v-if="venueData.logo"
                    :src="venueData.logo"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Website</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.website"
                    type="text"
                    placeholder="Website"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Map Directions</label>
          <hr>
          <div class="columns">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <input
                    v-model="venueData.mapquest"
                    type="text"
                    placeholder="Map Directions"
                    class="input"
                  >
                </p>
              </div>
            </div>
          </div>

          <label class="label">Notes</label>
          <hr>
          <div class="columns is-multiline">
            <div class="column is-5">
              <div class="field">
                <p class="control">
                  <textarea
                    v-model="venueData.notes"
                    placeholder="Notes"
                    class="textarea"
                    rows="5"
                  />
                </p>
              </div>
            </div>
          </div>

          <label class="label">Options</label>
          <hr>
          <p class="control">
            <input
              v-model="venueData.smoke"
              type="checkbox"
              class="checkbox"
              :checked="venueData.smoke"
            > &nbsp;Non-Smoking
            <input
              v-model="venueData.wifi"
              type="checkbox"
              class="checkbox"
              :checked="venueData.wifi"
            > &nbsp;Wi-Fi
            <input
              v-model="venueData.pool"
              type="checkbox"
              class="checkbox"
              :checked="venueData.pool"
            > &nbsp;Pool
            <input
              v-model="venueData.music"
              type="checkbox"
              class="checkbox"
              :checked="venueData.music"
            > &nbsp;Music
            <input
              v-model="venueData.sports"
              type="checkbox"
              class="checkbox"
              :checked="venueData.sports"
            > &nbsp;Sport
          </p>
        </div>
        <div class="columns">
          <div class="column is-12">
            <hr>
            <div class="is-pulled-right">
              <div
                class="button is-info"
                @click="saveVenue()"
              >
                Save
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import DatePicker from '../../helpers/Datepicker.vue'
  import vueDropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    name: 'ToolsEditVenue',
    components: {
      DatePicker,
      vueDropzone
    },
    props: {
      token: {
        type: String,
      },
      user: {
        type: Object,
      },
      isNew: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        venueData: {
        },
        dropzoneOptions: {
          dictDefaultMessage: 'Click here to upload a venue logo',
          url: '//rest.ahlpoker.com/image/upload/venues',
          thumbnailWidth: 150,
          maxFilesize: 10,
          paramName: 'file',
          resizeHeight: 125,
          resizeWidth: 125,
          acceptedFiles: 'image/*',
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560'
          },
          success: (file, res) => {
            if (file.previewElement) {
              return file.previewElement.classList.add('dz-success')
            }
            console.log(this)
            JSON.parse(res).link
          }
        },
        selectedRegion: {},
        showPermissions: false,
        linkMyAHLDialogVisible: true,
        regions: [],
        regionDropdown: false
      }
    },
    mounted: function () {
      this.getRegions()
    },
    methods: {
      create() {
        console.log(this.$route.params)
      },
      saveVenue() {
        if (this.validateFields()) {
          let data = {
            token: this.token,
            venueData: this.venueData
          }
          let url = `admin/venues/save`
          this.$axios({
            method: 'POST',
            url,
            headers: {
              Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            data
          })
            .then((res) => {
              this.$emit('message', {
                showDialog: true,
                error: res.data.error,
                message: res.data.message
              })
            })
            .catch((error) => {
              console.log(error)
            })
        }
      },
      validateFields() {
        let mandatoryFields = {
          name: 'Venue name is missing',
          rep: 'Representative is missing',
          street1: 'Street 1 is missing',
          city: 'City is missing',
          state: 'State is missing',
          phone: 'Phone is missing',
          region: 'Region is missing',
          startdate: 'Start date is missing',
        }
        for (var x in mandatoryFields) {
          if ((this.venueData[x] && this.venueData[x].length === 0) || !this.venueData[x]) {
            this.$emit('message', {
              showDialog: true,
              error: true,
              message: mandatoryFields[x]
            })
            return false
          }
        }
        return true
      },
      goBack() {
        this.$router.push('/admin/venues')
      },
      selectRegion(region) {
        this.venueData.region = region.region
        this.selectedRegion = region
        this.regionDropdown = false
      },
      dateFormatter(date) {
        return date.getYear() + '-' + date.getMonth() + '-' + date.getDay()
      },
      getRegions() {
        let url = `admin/venues/getregions`
        let data = {
          token: this.token
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.regions = res.data
            this.selectedRegion = res.data[0]
            this.venueData.region = res.data[0].region
            this.getVenueInfo(this.$route.params.id)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      getVenueInfo(id) {
        let getUrl = `admin/venues/get/` + id
        let data = {
          token: this.token,
          venueId: id
        }
        this.$axios({
          method: 'POST',
          url: getUrl,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.venueData = res.data
            this.venueData.smoke = res.data.smoke === '1'
            this.venueData.wifi = res.data.wifi === '1'
            this.venueData.pool = res.data.pool === '1'
            this.venueData.music = res.data.music === '1'
            this.venueData.sports = res.data.sports === '1'
            console.log("Returned region", this.venueData.region)
            console.log(this.regions);
            for (let x in this.regions) {
              if (this.regions[x].region === this.venueData.region) {
                this.selectedRegion = this.regions[x]
                break
              }
            }
            this.updateActive(res.data.active)
          })
          .catch((error) => {
            console.log(error.response)
          })
      },
      getVenueLogoLink (file, res) {
        this.venueData.logo = res.link
        this.$refs.venueLogo.removeAllFiles()
      },
      updateActive(result) {
        if (result) {
          this.venueData.active = result
        } else {
          this.venueData.active = !this.venueData.active
        }
      }
    }
  }
</script>
